// TennisTrack Hub — Landing Page Pubblica | 029 Project
// Pagina visibile senza login — ottimizzata per SEO
import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

// Features principali
const FEATURES = [
  {
    icon: '🎾',
    titolo: 'Gestione Atleti',
    descrizione: 'Profili completi per ogni atleta con dati fisici, storico allenamenti, pacchetti lezioni e molto altro.'
  },
  {
    icon: '💪',
    titolo: 'Allenamenti Dettagliati',
    descrizione: 'Registra ogni sessione con esercizi specifici per tennis o fitness, difficoltà, serie e video YouTube collegati.'
  },
  {
    icon: '📋',
    titolo: 'Libreria Template',
    descrizione: 'Crea schede allenamento riutilizzabili e condividile con la community dei maestri TennisTrack Hub.'
  },
  {
    icon: '📄',
    titolo: 'PDF Professionale',
    descrizione: 'Genera report PDF personalizzati da inviare ai tuoi atleti con il tuo branding. Disponibile nel piano Premium.'
  },
  {
    icon: '🔔',
    titolo: 'Notifiche in-app',
    descrizione: 'Tieniti aggiornato: approvazioni template, aggiornamenti e messaggi importanti direttamente nell\'app.'
  },
  {
    icon: '📊',
    titolo: 'Dashboard & Analytics',
    descrizione: 'Panoramica completa della tua attività: atleti attivi, lezioni programmate, allenamenti del mese.'
  }
];

const LandingPage = () => {
  return (
    <div className="landing">

      {/* ── META SEO (gestito in public/index.html + Helmet non disponibile senza libreria) ── */}

      {/* ── NAVBAR ── */}
      <nav className="landing-nav">
        <div className="landing-nav-logo">
          <Link to="/">
            <img src="/img/logo_tennistrack_300x800.png" alt="TennisTrack Hub — Gestione Atleti Tennis e Fitness" />
          </Link>
        </div>

        <div className="landing-nav-links">
          <a href="#features">Funzionalità</a>
          <a href="#piani">Prezzi</a>
        </div>

        <div className="landing-nav-cta">
          <Link to="/login" className="btn-landing-secondary">Accedi</Link>
          <Link to="/register" className="btn-landing-primary">Inizia gratis →</Link>
        </div>
      </nav>

      {/* ── HERO ── */}
      <header className="landing-hero">
        <div className="landing-hero-badge">🎾 Per maestri di tennis e fitness</div>
        <h1>
          Gestisci i tuoi atleti.<br />
          <span>Professionalizza il tuo lavoro.</span>
        </h1>
        <p className="landing-hero-subtitle">
          TennisTrack Hub è la piattaforma pensata per maestri di tennis e personal trainer.
          Gestisci atleti, allenamenti, template e pagamenti in un unico posto.
        </p>
        <div className="landing-hero-cta">
          <Link to="/register" className="btn-landing-primary">
            🚀 Crea il tuo account gratis
          </Link>
          <Link to="/login" className="btn-landing-secondary">
            Hai già un account? →
          </Link>
        </div>
        <p className="landing-hero-note">✓ Gratuito per iniziare &nbsp;·&nbsp; ✓ Nessuna carta di credito richiesta &nbsp;·&nbsp; ✓ Setup in 2 minuti</p>
      </header>

      {/* ── STATS ── */}
      <div className="landing-stats">
        <div className="landing-stat">
          <span className="landing-stat-num">∞</span>
          <span className="landing-stat-label">Atleti gestibili</span>
        </div>
        <div className="landing-stat">
          <span className="landing-stat-num">100+</span>
          <span className="landing-stat-label">Template pronti</span>
        </div>
        <div className="landing-stat">
          <span className="landing-stat-num">PDF</span>
          <span className="landing-stat-label">Export professionale</span>
        </div>
        <div className="landing-stat">
          <span className="landing-stat-num">€9,99</span>
          <span className="landing-stat-label">Piano Premium/mese</span>
        </div>
      </div>

      {/* ── FEATURES ── */}
      <section className="landing-section" id="features">
        <h2 className="landing-section-title">Tutto quello che ti serve, in un unico hub</h2>
        <p className="landing-section-sub">
          Smetti di usare fogli Excel e app generiche. TennisTrack Hub è costruito per chi allena.
        </p>
        <div className="landing-features-grid">
          {FEATURES.map((f, i) => (
            <div className="landing-feature-card" key={i}>
              <div className="landing-feature-icon">{f.icon}</div>
              <h3>{f.titolo}</h3>
              <p>{f.descrizione}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── PIANI ── */}
      <section className="landing-section landing-plans" id="piani">
        <h2 className="landing-section-title">Semplice e trasparente</h2>
        <p className="landing-section-sub">Inizia gratis, passa a Premium quando sei pronto.</p>
        <div className="landing-plans-grid">

          <div className="landing-plan-card">
            <div className="landing-plan-name">Free</div>
            <div className="landing-plan-price">€0 <span>/mese</span></div>
            <div className="landing-plan-desc">Per iniziare senza impegno</div>
            <ul className="landing-plan-features">
              <li>Atleti illimitati</li>
              <li>Allenamenti illimitati</li>
              <li>Fino a 4 template personali</li>
              <li>Dashboard & statistiche</li>
              <li>Video YouTube collegati</li>
            </ul>
            <Link to="/register" className="btn-landing-secondary" style={{ display: 'block', textAlign: 'center' }}>
              Inizia gratis
            </Link>
          </div>

          <div className="landing-plan-card featured">
            <div className="landing-plan-badge">⭐ Più popolare</div>
            <div className="landing-plan-name">Premium</div>
            <div className="landing-plan-price">€9,99 <span>/mese</span></div>
            <div className="landing-plan-desc">Per i professionisti del coaching</div>
            <ul className="landing-plan-features">
              <li>Tutto del piano Free</li>
              <li>Template illimitati</li>
              <li>Export PDF professionale</li>
              <li>Commenti ai template della community</li>
              <li>Condividi template con la community</li>
              <li>Supporto prioritario</li>
            </ul>
            <Link to="/register" className="btn-landing-primary" style={{ display: 'block', textAlign: 'center' }}>
              Prova Premium →
            </Link>
          </div>

        </div>
      </section>

      {/* ── CTA FINALE ── */}
      <section className="landing-cta-section">
        <h2>Pronto a professionalizzare il tuo coaching?</h2>
        <p>Unisciti ai maestri che gestiscono i loro atleti con TennisTrack Hub.</p>
        <Link to="/register" className="btn-landing-primary">
          🎾 Crea il tuo account gratis
        </Link>
      </section>

      {/* ── FOOTER ── */}
      <footer className="landing-footer">
        <Link to="/">
          <img src="/img/madeby029.png" alt="029 Project" style={{ height: '24px', opacity: 0.6 }} />
        </Link>

        <div className="landing-footer-links">
          <a href="#features">Funzionalità</a>
          <a href="#piani">Prezzi</a>
          <Link to="/login">Accedi</Link>
          <Link to="/register">Registrati</Link>
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          <a href="/cookie-policy" target="_blank" rel="noopener noreferrer">Cookie Policy</a>
        </div>

        <div className="landing-footer-copy">
          © {new Date().getFullYear()} TennisTrack Hub — 029 Project
        </div>
      </footer>

    </div>
  );
};

export default LandingPage;
